var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53054 7.2H4.88761V8.8H3.53054V7.2ZM13.03 3.2V14.4C13.03 15.28 12.4193 16 11.6729 16H2.17347C1.81356 16 1.46838 15.8314 1.21388 15.5314C0.959383 15.2313 0.816406 14.8243 0.816406 14.4L0.823192 3.2C0.823192 2.32 1.4203 1.6 2.17347 1.6H2.85201V0H4.20908V1.6H9.63735V0H10.9944V1.6H11.6729C12.4193 1.6 13.03 2.32 13.03 3.2ZM2.17347 4.8H11.6729V3.2H2.17347V4.8ZM11.6729 14.4V6.4H2.17347V14.4H11.6729ZM8.95881 8.8H10.3159V7.2H8.95881V8.8ZM6.24468 8.8H7.60175V7.2H6.24468V8.8Z",
    fill: "#001984"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a7ea28bffc1191e447af7b0f43849fac.svg";
export { ForwardRef as ReactComponent };